export const initialState = {
    panelWidgets: [],
    disableWidgets: [],
    lastRowIndex: 0,
    defaultWidgetSettings: [],
};

const state = { ...initialState };

export default state;